import { render, staticRenderFns } from "./RouteHandler.vue?vue&type=template&id=8078c678"
import script from "./RouteHandler.vue?vue&type=script&lang=js"
export * from "./RouteHandler.vue?vue&type=script&lang=js"
import style0 from "./RouteHandler.vue?vue&type=style&index=0&id=8078c678&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports